import globals from "@lvt/globals";
import { NavMenu } from "@lvt/vertical-navbar";
import { ListItemIcon, Link, ListItemText, MenuItem } from "@material-ui/core";
import { AccountCircleOutlined, ExitToApp } from "@material-ui/icons";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";
import { FC } from "react";

import { useSelector } from "@/store";


interface MyAccountProps {
    portalUrl: string;
}

const MyAccount: FC<MyAccountProps> = ({ portalUrl }) => {
    const { id, name } = useSelector((state) => state.user);

    const handleSignOut = () => {
        // Delete the LVTAUTH cookie for backwards compatibility per SecOps request
        // This is a security measure that cleans up the cookie after logout
        const client = applyCaseMiddleware(axios.create({
            baseURL: `${globals.nextApp.url}/api/cookies/delete`,
            withCredentials: true,
        }));

        client.delete("/api/cookies/delete").catch((error) => {
            console.error("MyAccount Cookies delete error: ", error);
        });
    };

    return (
        <>
            {id && name &&
                <NavMenu icon={<AccountCircleOutlined />} label="My Account">
                    <Link
                        target="_blank"
                        color="textPrimary"
                        href={`${portalUrl}/users/view/${id}`}
                        underline="none"
                    >
                        <MenuItem>
                            <ListItemIcon>
                                <AccountCircleOutlined />
                            </ListItemIcon>
                            <ListItemText>{name}</ListItemText>
                        </MenuItem>
                    </Link>
                    <Link
                        color="textPrimary"
                        href={`${globals.nextApp.url}/auth/signin?logout=true`}
                        underline="none"
                    >
                        <MenuItem onClick={handleSignOut}>
                            <ListItemIcon>
                                <ExitToApp />
                            </ListItemIcon>
                            <ListItemText>Sign Out</ListItemText>
                        </MenuItem>
                    </Link>
                </NavMenu>
            }
        </>
    );
};

export default MyAccount;
